// Offer names that should display the "New" badge.
// Managed entirely on the frontend — remove a name here when the offer is no longer new.
export const NEW_OFFER_NAMES = [
  'welcome_beverage',
  'wine_tasting',
  'winter_package',
]

/**
 * Hotel offer icon mappings
 * Maps offer type identifiers to their icon URLs
 * Icons are resolved at build time using Vite's URL import
 */

const icons = {
  mini_bar: new URL('/src/assets/img/hotel-offers/icons/mini_bar.png', import.meta.url),
  free_breakfast: new URL('/src/assets/img/hotel-offers/icons/free_breakfast.png', import.meta.url),
  water_refreshments: new URL('/src/assets/img/hotel-offers/icons/mini_bar.png', import.meta.url),
  room_upgrade: new URL('/src/assets/img/hotel-offers/icons/room_upgrade.png', import.meta.url),
  early_check_in: new URL('/src/assets/img/hotel-offers/icons/early_check_in.png', import.meta.url),
  late_check_out: new URL('/src/assets/img/hotel-offers/icons/late_check_out.png', import.meta.url),
  public_transportation: new URL('/src/assets/img/hotel-offers/icons/public_transportation.png', import.meta.url),
  outdoor_equipment: new URL('/src/assets/img/hotel-offers/icons/outdoor_equipment.png', import.meta.url),
  spa_treatments: new URL('/src/assets/img/hotel-offers/icons/spa_treatments.png', import.meta.url),
  classic_sauna: new URL('/src/assets/img/hotel-offers/icons/classic_sauna.png', import.meta.url),
  jacuzzi_access: new URL('/src/assets/img/hotel-offers/icons/jacuzzi_access.png', import.meta.url),
  guided_tours: new URL('/src/assets/img/hotel-offers/icons/guided_tours.png', import.meta.url),
  co_working_space: new URL('/src/assets/img/hotel-offers/icons/co_working_space.png', import.meta.url),
  guest_parking: new URL('/src/assets/img/hotel-offers/icons/guest_parking.png', import.meta.url),
  airport_shuttle: new URL('/src/assets/img/hotel-offers/icons/airport_shuttle.png', import.meta.url),
  hotel_restaurant: new URL('/src/assets/img/hotel-offers/icons/hotel_restaurant.png', import.meta.url),
  direct_booking_discount: new URL('/src/assets/img/hotel-offers/icons/direct_booking_discount.png', import.meta.url),
  premium_perks: new URL('/src/assets/img/hotel-offers/icons/premium_perks.png', import.meta.url),
  seasonal_offer: new URL('/src/assets/img/hotel-offers/icons/seasonal_offer.png', import.meta.url),
  romantic_package: new URL('/src/assets/img/hotel-offers/icons/romantic_package.png', import.meta.url),
  christmas_package: new URL('/src/assets/img/hotel-offers/icons/christmas_package.png', import.meta.url),
  new_year_package: new URL('/src/assets/img/hotel-offers/icons/new_year_package.png', import.meta.url),
  ski_package: new URL('/src/assets/img/hotel-offers/icons/ski_package.png', import.meta.url),
  safari_package: new URL('/src/assets/img/hotel-offers/icons/safari_package.png', import.meta.url),
  summer_package: new URL('/src/assets/img/hotel-offers/icons/summer_package.png', import.meta.url),
  golf_package: new URL('/src/assets/img/hotel-offers/icons/golf_package.png', import.meta.url),
  diving_package: new URL('/src/assets/img/hotel-offers/icons/diving_package.png', import.meta.url),
  wellness_package: new URL('/src/assets/img/hotel-offers/icons/wellness_package.png', import.meta.url),
  easter_package: new URL('/src/assets/img/hotel-offers/icons/easter_package.png', import.meta.url),
  welcome_beverage: new URL('/src/assets/img/hotel-offers/icons/mini_bar.png', import.meta.url),
  wine_tasting:     new URL('/src/assets/img/hotel-offers/icons/wine_tasting.png', import.meta.url),
  winter_package:   new URL('/src/assets/img/hotel-offers/icons/winter_package.png', import.meta.url),
} as const

export default icons

/** Union type of all hotel offer icon keys */
export type HotelOfferIconKey = keyof typeof icons

/** Type of icon URL object */
export type IconUrl = URL